import React from "react";
import { Container, Row, Col } from "reactstrap";
import ViewUploadResume from "./viewUploadedResume";
import {Link} from 'react-router-dom'

// parent view uploaded component to render child uploaded resume
const MainPart = (props) => {
  return (
    <Container
      style={{ maxWidth: "75%", marginTop: "40px !important" }}
      className="card container-card migrator-mt personalDetails-div-1"
    >
      <Link  to="/dashboard/my_profile">
        <i
          className="material-icons contact-cancel-button pointer"
          onClick={props.back}
        >
          cancel
        </i>
      </Link>
      <Row>

        <Col md="12" className=" profile-contact-details-col mx-auto">
          <ViewUploadResume />
        </Col>
      </Row>
    </Container>
  );
};

export default MainPart ;
